<div class="container-scroller">
  <app-navbar *ngIf="showNavbar" [hidden]="isHidden()"></app-navbar>
  <div class="container-fluid page-body-wrapper pb0 pb-0">
    <app-sidebar *ngIf="showSidebar" [hidden]="isHidden()"></app-sidebar>
    <div class="main-panel pl-2" [ngClass]="{'main-panel-only' : isHidden()}">
      <div class="content-wrapper" [ngClass]="{'content-wrapper-main' : isHidden()}">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <!-- <app-footer *ngIf="showFooter" [hidden]="isHidden()"></app-footer> -->
</div>